import React from 'react';
import { TouchableOpacity, Platform } from 'react-native';
import { MdSave } from 'react-icons/md';

type SaveFabProps = {
  visible?: boolean;
  saving?: boolean;
  onPress?: () => void;
  bottomOffset?: number;
};

const SaveFab: React.FC<SaveFabProps> = ({ visible = true, saving = false, onPress, bottomOffset = 24 }) => {
  if (!visible) return null;
  const webLift = 80; // match FAB lift so both buttons align vertically above bottom nav
  const style: any = {
    position: Platform.OS === 'web' ? 'fixed' as any : 'absolute',
    right: 24,
    bottom: (Platform.OS === 'web' ? bottomOffset + webLift : 24) + 64,
    zIndex: 2147483649,
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: saving ? 'rgba(251,122,74,0.85)' : '#FB7A4A',
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#FB7A4A',
    shadowOpacity: 0.18,
    shadowOffset: { width: 0, height: 6 },
    shadowRadius: 10,
    elevation: 6,
  };

  return (
    <TouchableOpacity onPress={onPress} disabled={saving} style={style}>
      {React.createElement(MdSave as any, { style: { color: '#fff', fontSize: 20 } })}
    </TouchableOpacity>
  );
};

export default SaveFab;
